import React, { useMemo} from "react";
import {Empty} from "antd";

const SiloPositionVisualizer = ({ totalLocations, occupiedPositions, activePosition, selectedGroupType }) => {
    // Generate SVG coordinates for positions in a circle, plus the center
    const SVG_WIDTH = 500;
    const SVG_HEIGHT = totalLocations === 32 ? 350 : 500; // Rectangular height for 32-pos
    const SVG_CENTER_X = SVG_WIDTH / 2; // 250
    const SVG_CENTER_Y = SVG_HEIGHT / 2; // 175 for rectangular, 250 for circular
    console.log(selectedGroupType)

  const generateCircularPoints = (startId, count, radius, offsetAngleDegrees = -90,type, startIndex = 0) => {
        const points = [];
        const angleStep = 360 / count;

        for (let i = 0; i < count; i++) {
          const angle = ((i + startIndex) * angleStep) + offsetAngleDegrees;
            const radians = angle * (Math.PI / 180);

            const x = SVG_CENTER_X + radius * Math.cos(radians);
            const y = SVG_CENTER_Y + radius * Math.sin(radians);
            const id = startId + i;

            points.push({
                id: id,
                label: id,
                x: Math.round(x),
                y: Math.round(y),
                value: `cable_${id}`,
                type: type // Assuming inner/outer based on ID range
            });
        }
        return points;
    };
    const POS_COORDINATE_MAPS = {
        8: (() => {
            const map = [];


          map.push({ id: 1, label: 1, x: 250, y: 250, value: `cable_1`, type: 'center' });

            const centerPoints = generateCircularPoints(2, 7, 150, 20, 'center_ring',2);
            map.push(...centerPoints);


            return map;
        })(),
        32:  (() => {
            const map = [];
            const rows = 4;
            const cols = 8;
            // Dimensions of the visualization area within the SVG: 400 wide (from 50 to 450), 200 high (from 75 to 275)
            const areaWidth = 400;
            const areaHeight = 200;
            const paddingX = 50;
            const paddingY = 75;

            const stepX = areaWidth / (cols - 1); // Step size for 8 columns (7 intervals)
            const stepY = areaHeight / (rows - 1); // Step size for 4 rows (3 intervals)

            const CABLE_ID_REMAP = [
                25, 26, 27, 28, 29, 30, 31, 32, 17, 18, 19, 20, 21, 22, 23, 24,
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16
            ];


            for (let i = 0; i < 32; i++) {
                const row = Math.floor(i / cols);
                const col = i % cols;
                const gridPositionId = i + 1; // 1 to 32

                const physicalCableId = CABLE_ID_REMAP[i];

                map.push({
                    id: gridPositionId,
                    label: physicalCableId,

                    x: paddingX + col * stepX,
                    y: paddingY + row * stepY,
                    value: `cable_${physicalCableId}`, // Use the mapped cable ID for the dropdown value
                    type: 'grid'
                });
            }
            return map;
        })(),
              43: (() => {
            const map = [];


          map.push({ id: 1, label: 1, x: 250, y: 250, value: `cable_1`, type: 'center' });

            const centerPoints = generateCircularPoints(2, 3, 50, -50, 'center_ring',2);
            map.push(...centerPoints);


            const innerPoints = generateCircularPoints(5, 13, 100, -90, 'inner',7); // Corrected Count to 13 (5 to 17)
            map.push(...innerPoints);


            const outerPoints = generateCircularPoints(18, 13, 160, -90 + (360/26), 'outer',6);
            map.push(...outerPoints);

            const finalPoints = generateCircularPoints(31, 13, 220, -90 + (360/26), 'final',6); // Corrected Count to 13 (31 to 43)
            map.push(...finalPoints);
            return map;
        })(),

    };
      const positions = useMemo(() => {
        // Select the correct map based on totalLocations, fallback to default 8-pos if not found
        const map = POS_COORDINATE_MAPS[totalLocations] || POS_COORDINATE_MAPS[8];

        // Ensure positions are returned only up to totalLocations limit if map is larger
        return map.slice(0, totalLocations);
    }, [totalLocations]);

     const isCircular = totalLocations !== 32;

   const groupedPositions = useMemo(() => {
        if (!isCircular) return {};

        const groups = { center_ring: [], inner: [], outer: [], final: [] };
        positions.forEach(pos => {
            if (pos.type === 'center_ring') groups.center_ring.push(pos);
            else if (pos.type === 'inner') groups.inner.push(pos);
            else if (pos.type === 'outer') groups.outer.push(pos);
            else if (pos.type === 'final') groups.final.push(pos);
        });
        return groups;
    }, [positions, isCircular]);
  const renderConnectingLines = (ringPositions) => {
        if (ringPositions.length < 2) return null;

        const lines = [];

const sorted = [...ringPositions].sort((a, b) => {
  const aAngle = Math.atan2(a.y - SVG_CENTER_Y, a.x - SVG_CENTER_X);
  const bAngle = Math.atan2(b.y - SVG_CENTER_Y, b.x - SVG_CENTER_X);
  return aAngle - bAngle;
});

const closedLoopPositions = [...sorted, sorted[0]];
        for (let i = 0; i < closedLoopPositions.length - 1; i++) {
            const p1 = closedLoopPositions[i];
            const p2 = closedLoopPositions[i + 1];

            lines.push(
                <line
                    key={`conn-${p1.id}-${p2.id}`}
                    x1={p1.x} y1={p1.y} x2={p2.x} y2={p2.y}
                    stroke="#aaa"
                    strokeWidth="1"
                    strokeDasharray="3,3" // Slightly tighter dash for subtlety
                />
            );
        }
        return lines;
    };
if (selectedGroupType === 4) {
    return <Empty description="No positions to display for this group type" />;
}
    return (


        <div
            style={{
                backgroundColor: '#fff',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                marginBottom: '24px',
                overflow: 'hidden'
            }}
        >
            <div style={{
                padding: '16px',
                fontWeight: '600',
                fontSize: '18px',
                color: '#fff',
                backgroundColor: '#38761d',
                borderRadius: '8px 8px 0 0',
            }}>
                Visual Position Map
                (1-{totalLocations})
            </div>

            <svg width="500" height={SVG_HEIGHT}  viewBox={`0 0 ${SVG_WIDTH} ${SVG_HEIGHT}`}  style={{border: '1px solid #ddd',borderRadius: isCircular ? '50%' : '4px' }}>

                {/* Outer Silo Ring */}
             {isCircular ? (
                    <circle cx={SVG_CENTER_X} cy={SVG_CENTER_Y} r={SVG_CENTER_X - 5} fill="none" stroke="#666" strokeWidth={3} />
                ) : (
                    <rect x="50" y="50" width="400" height="300" fill="none" stroke="#666" strokeWidth="3" />
                )}



                 {isCircular && groupedPositions.center_ring && renderConnectingLines(groupedPositions.center_ring)}
                {isCircular && groupedPositions.inner && renderConnectingLines(groupedPositions.inner)}
                {isCircular && groupedPositions.outer && renderConnectingLines(groupedPositions.outer)}
                {isCircular && groupedPositions.final && renderConnectingLines(groupedPositions.final)}
                {/* Draw Radial Segments */}
                {positions.map(pos => {
                    const isOccupied = occupiedPositions.has(pos.value);
                    const isActive = pos.value === activePosition;

                    let fill = '#eee';
                    let stroke = '#666';

                    if (isActive) {
                        fill = '#10B981';
                        stroke = '#059669';
                    } else if (isOccupied) {
                        fill = '#F59E0B';
                        stroke = '#D97706';
                    }

                    return (
                        <g key={pos.id}>
                            <circle
                                cx={pos.x} cy={pos.y}
                                r={isActive ? 12 : 10}
                                fill={fill} stroke={stroke}
                                strokeWidth={isActive ? 3 : 1}
                            />
                            <text
                                x={pos.x} y={pos.y} dy=".3em"
                                textAnchor="middle"
                                fontSize={isActive ? "14" : "12"}
                                fontWeight={isActive ? "bold" : "normal"}
                                fill={isActive || isOccupied ? "white" : "black"}
                                style={{pointerEvents: 'none'}}
                            >
                                {pos.label}
                            </text>
                        </g>
                    );
                })}


            </svg>
        </div>
    );
};

export default SiloPositionVisualizer